import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { toast } from "@/components/ui/sonner";
import { fetchVipCheckoutStatus } from "@/lib/api";
import { pickText } from "@/lib/content";

export const VipReturnPage = ({ language, onAccessResolved }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [statusText, setStatusText] = useState(pickText(language, "Preparing your VIP chamber…", "Preparazione della tua camera VIP…"));

  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    const email = searchParams.get("email") || "";

    if (!sessionId) {
      setStatusText(pickText(language, "No payment session was found.", "Nessuna sessione di pagamento trovata."));
      return;
    }

    let attempts = 0;
    let cancelled = false;

    const pollStatus = async () => {
      try {
        attempts += 1;
        const data = await fetchVipCheckoutStatus(sessionId);
        if (data.access_granted) {
          onAccessResolved(email || data.email, data);
          setStatusText(pickText(language, "VIP access confirmed. Entering the inner chamber…", "Accesso VIP confermato. Ingresso nella camera interiore…"));
          toast.success(pickText(language, "VIP access activated.", "Accesso VIP attivato."));
          setTimeout(() => navigate("/vip-chat"), 1200);
          return;
        }

        if (attempts < 5 && !cancelled) {
          setStatusText(pickText(language, "Checking Stripe payment status…", "Controllo dello stato del pagamento Stripe…"));
          setTimeout(pollStatus, 2000);
          return;
        }

        setStatusText(pickText(language, "Payment is still processing. Try verifying your email from the access gate.", "Il pagamento è ancora in elaborazione. Prova a verificare la tua email dalla porta di accesso."));
      } catch (error) {
        console.error(error);
        setStatusText(pickText(language, "We could not confirm payment yet. You can verify your email from the access gate.", "Non siamo ancora riusciti a confermare il pagamento. Puoi verificare la tua email dalla porta di accesso."));
      }
    };

    pollStatus();

    return () => {
      cancelled = true;
    };
  }, [language, navigate, onAccessResolved, searchParams]);

  return (
    <div className="mx-auto max-w-3xl" data-testid="vip-return-page">
      <div className="glass-card rounded-[2rem] p-8 md:p-10">
        <p className="section-label" data-testid="vip-return-eyebrow">
          {pickText(language, "Stripe Return", "Ritorno da Stripe")}
        </p>
        <h2 className="mt-4 text-4xl text-foreground" data-testid="vip-return-title">
          {pickText(language, "Completing your V.I.P. access", "Completamento del tuo accesso V.I.P.")}
        </h2>
        <p className="body-copy mt-4" data-testid="vip-return-status-text">
          {statusText}
        </p>
        <div className="mt-6">
          <Link className="ghost-button" data-testid="vip-return-home-link" to="/">
            {pickText(language, "Back to the temple entrance", "Torna all'ingresso del tempio")}
          </Link>
        </div>
      </div>
    </div>
  );
};